import script from "./UiChip.vue?vue&type=script&setup=true&lang=js"
export * from "./UiChip.vue?vue&type=script&setup=true&lang=js"

import "./UiChip.vue?vue&type=style&index=0&id=19e2c911&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e2c911"]])

export default __exports__